/**
 * @generated SignedSource<<ad137c21e0147f689e7bfb70be59bebd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemMediumStatusAndPrio_Todo$data = {
  readonly canWrite: boolean;
  readonly expireAt: string | null;
  readonly id: string;
  readonly isResponseCompleted: boolean;
  readonly ordinal: string;
  readonly priority: TodoPriority;
  readonly response: {
    readonly __typename: "TodoResponseImage";
    readonly images: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
    }>;
  } | {
    readonly __typename: "TodoResponseNumber";
  } | {
    readonly __typename: "TodoResponseText";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoOverviewListItemMediumStatusAndPrio_Todo";
};
export type TodoOverviewListItemMediumStatusAndPrio_Todo$key = {
  readonly " $data"?: TodoOverviewListItemMediumStatusAndPrio_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemMediumStatusAndPrio_Todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemMediumStatusAndPrio_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isResponseCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "TodoResponseNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "TodoResponseText",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Image_image"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TodoResponseImage",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "ffcdc02e3f01ed94e0c7032a6a018304";

export default node;
